import { render } from "./PromotionDetailPage.vue?vue&type=template&id=071a0bf8&scoped=true"
import script from "./PromotionDetailPage.vue?vue&type=script&lang=js"
export * from "./PromotionDetailPage.vue?vue&type=script&lang=js"

import "./PromotionDetailPage.vue?vue&type=style&index=0&id=071a0bf8&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071a0bf8"]])

export default __exports__